import LayoutSidebar from "../../components/layoutSidebar/layoutSidebar";
import Chart from "../../components/chart/chart";

const Charts = () => {
  return (
    <>
      <LayoutSidebar>
        <Chart />
      </LayoutSidebar>
    </>
  )
}
export default Charts;